explainerGiveViews